import { Member } from "../../../types/employee.types";
import { CommonDetails, OpenEnrollmentWithPlan, StandardDetails } from "../../../types/enrollment.types";
import { waiveReasonProps } from "../../../types/waiveReason.types";
import { getCurrentDate } from "../date";

export const generateWaiveEnrollmentPayload = (
	member: Member,
	openEnrollment: OpenEnrollmentWithPlan,
	waiveReason: string,
	selectedPlan?: any
): {
	standardDetails: StandardDetails[];
	commonDetails: CommonDetails;
} => {
	const standardDetails: StandardDetails[] = [
		{
			member_object_id: member._id,
			coverage_code: "EE",
			member_SSN: member.SSN,
			premium_amount: 0,
			is_tobacco: false
		}
	];
	const commonDetails: CommonDetails = {
		agent_id: null,
		location_number: member.location.location_number,
		location_name: member.location.location_name,
		group_number: member.group_number,
		group_name: member.group.name,

		// openen enrollment details are not fetched for plan having always open true in database
		plan_object_id: openEnrollment ? openEnrollment.plan._id : selectedPlan ? selectedPlan._id : null,
		plan_code: openEnrollment ? openEnrollment.plan.plan_code : selectedPlan ? selectedPlan.plan_code : null,
		plan_name: openEnrollment ? openEnrollment.plan.plan_name : selectedPlan ? selectedPlan.plan_name : null,
		base_plan_name: openEnrollment ? openEnrollment.plan.plan_name : selectedPlan ? selectedPlan.plan_name : null,
		open_enrollment_id: openEnrollment ? openEnrollment._id : null,

		enrollment_status: "WAIVED",
		insured_object_id: member._id,
		insured_SSN: member.SSN,
		writing_number: 0,
		unenrolled_reason: null,
		waive_reason: waiveReason,
		termination_reason: null,
		enrollment_date: getCurrentDate(),
		effective_date: getCurrentDate(),
		termination_date: null
	};
	return {
		commonDetails,
		standardDetails
	};
};

export const generatePLWaiveEnrollmentPayload = (
	member: Member,
	openEnrollment: OpenEnrollmentWithPlan,
	waiveReason: waiveReasonProps
): {
	standardDetails: StandardDetails[];
	commonDetails: CommonDetails;
} => {
	const standardDetails: StandardDetails[] = [
		{
			member_object_id: member._id,
			coverage_code: "EE",
			member_SSN: member.SSN,
			premium_amount: 0,
			is_tobacco: false
		}
	];
	const commonDetails: CommonDetails = {
		agent_id: null,
		location_number: member.location.location_number,
		location_name: member.location.location_name,
		group_number: member.group_number,
		group_name: member.group.name,
		plan_object_id: openEnrollment.plan._id,
		plan_code: openEnrollment.plan.plan_code,
		plan_name: openEnrollment.plan.plan_name,
		base_plan_name: openEnrollment.plan.plan_name,
		enrollment_status: "WAIVED",
		insured_object_id: member._id,
		insured_SSN: member.SSN,
		writing_number: 0,
		unenrolled_reason: null,
		waive_reason: waiveReason?.waive_reason,
		another_group_insurance: waiveReason?.another_group_insurance,
		is_employee_cost: waiveReason?.is_employee_cost,
		termination_reason: null,
		enrollment_date: getCurrentDate(),
		effective_date: getCurrentDate(),
		termination_date: null,
		open_enrollment_id: openEnrollment._id
	};
	return {
		commonDetails,
		standardDetails
	};
};

export const generateHealthPlanWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateClinicCardWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateKsopWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateGltdWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateGstdWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateGliWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateChristmasClubWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateGSTDWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateGLTDClass2WaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateGLIWaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generateGLTDClass1WaiveEnrollmentPayload = generateWaiveEnrollmentPayload;
export const generatePLabsWaiveEnrollmentPayload = generatePLWaiveEnrollmentPayload;
